export const menuCategories = [
  {
    id: 'bocadillos',
    name: 'Bocadillos',
    icon: 'ri-restaurant-line',
    items: [
      {
        id: 1,
        name: 'Bocadillo Kebab',
        description: 'Kebab de ternera o pollo con ensalada fresca y salsas',
        price: '5,00€',
        category: 'Bocadillos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/d1ea630b370907a222a32672af39000f.jpeg'
      },
      {
        id: 2,
        name: 'Bocadillo Kebab Mixto',
        description: 'Kebab mixto de ternera o pollo con ensalada fresca y salsas',
        price: '5,00€',
        category: 'Bocadillos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/134be5bfa5c3b68e20d3ae61df8d361b.jpeg'
      },
      {
        id: 3,
        name: 'Bocadillo Kebab Doble',
        description: 'Doble de kebab de ternera o pollo con ensalada fresca y salsas',
        price: '6,50€',
        category: 'Bocadillos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/84e70fb17a239dc83c346cb5e1a9f154.jpeg'
      },
      {
        id: 4,
        name: 'Bocadillo Kebab con Queso',
        description: 'Kebab de ternera o pollo con queso, ensalada fresca y salsas',
        price: '6,50€',
        category: 'Bocadillos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/b618d18853b1dae4be25de8590f09324.jpeg'
      },
      {
        id: 5,
        name: 'Bocadillo Kebab Solo Carne',
        description: 'Solo carne de kebab de ternera o pollo con salsas',
        price: '6,50€',
        category: 'Bocadillos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/08aaed94ca3c6940088b9710ab9f8629.jpeg'
      },
      {
        id: 6,
        name: 'Bocadillo Vegetal',
        description: 'Bocadillo con ensalada fresca y salsas',
        price: '4,50€',
        category: 'Bocadillos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/5a33d3fd33b35b4805cce5a4bbdb57cf.jpeg'
      },
      {
        id: 7,
        name: 'Bocadillo Falafel',
        description: 'Falafel crujiente con ensalada fresca y salsas',
        price: '4,50€',
        category: 'Bocadillos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/eab801b9087ba8358a9e40adb79ddadf.jpeg'
      }
    ]
  },
  {
    id: 'durum',
    name: 'Durum',
    icon: 'ri-file-list-line',
    items: [
      {
        id: 8,
        name: 'Durum',
        description: 'Enrollado de ternera o pollo en pan de pita con ensalada y salsas',
        price: '6,50€',
        category: 'Durum',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/0fc96b86069ca05b9deda0f399561d59.jpeg'
      },
      {
        id: 9,
        name: 'Durum Doble',
        description: 'Doble de carne de ternera o pollo enrollado en pan de pita con ensalada y salsa',
        price: '7,50€',
        category: 'Durum',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/0fc96b86069ca05b9deda0f399561d59.jpeg'
      },
      {
        id: 10,
        name: 'Durum Solo Carne',
        description: 'Solo carne de ternera o pollo con salsa',
        price: '7,50€',
        category: 'Durum',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/cd1d0e8daf92ee7a08fb8e6d7e32d608.jpeg'
      }
    ]
  },
  {
    id: 'pizzas',
    name: 'Pizzas Lawasa',
    icon: 'ri-cake-line',
    items: [
      {
        id: 11,
        name: 'Lawasa Twister',
        description: 'Pizza enrollada con carne de ternera o pollo, tomate, pimiento, especias y ensalada',
        price: '7,50€',
        category: 'Pizzas',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/ef34d78fbacce4bdf42c83f7dc3bdfa5.jpeg'
      },
      {
        id: 12,
        name: 'Lawasa Doble',
        description: 'Doble de carne de ternera o pollo con tomate, pimiento, especias y ensalada',
        price: '7,50€',
        category: 'Pizzas',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/a174d816ba0d2b45f520de43051e0883.jpeg'
      }
    ]
  },
  {
    id: 'platos',
    name: 'Platos',
    icon: 'ri-restaurant-2-line',
    items: [
      {
        id: 13,
        name: 'Plato Kebab',
        description: 'Pan, carne y ensalada',
        price: '7,50€',
        category: 'Platos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/3858039eedd2267df918f58de891c942.png'
      },
      {
        id: 14,
        name: 'Plato Kebab de la Casa',
        description: 'Plato especial de la casa con kebab de ternera o pollo, patatas, ensalada y salsas',
        price: '8,50€',
        category: 'Platos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/78328e389926c0d1fbde1cf62585e660.jpeg'
      },
      {
        id: 15,
        name: 'Plato Kebabish',
        description: 'Queso, falafel, ensalada, salsa, patata, pan tostado y carne',
        price: '9,50€',
        category: 'Platos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/f8df79447980cc79e374ed288d43928a.png'
      },
      {
        id: 16,
        name: 'Plato Kebab con Patatas y Arroz',
        description: 'Plato de kebab de ternera o pollo con patatas fritas, arroz, ensalada y salsas',
        price: '9,00€',
        category: 'Platos',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/9beaa940d06c1179098d5ae684f077e2.jpeg'
      }
    ]
  },
  {
    id: 'raciones',
    name: 'Raciones',
    icon: 'ri-bowl-line',
    items: [
      {
        id: 17,
        name: 'Patatas Fritas',
        description: 'Patatas fritas crujientes y doradas',
        price: '4,00€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/22fb39c5094493d4febba914a05914a4.jpeg'
      },
      {
        id: 18,
        name: 'Ración de Carne',
        description: 'Generosa ración de carne a la parrilla',
        price: '6,00€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/f9127f65ca0fbeb4f1bc054061cb79ea.jpeg'
      },
      {
        id: 19,
        name: 'Nuggets de Pollo (6 uds)',
        description: 'Nuggets de pollo crujientes',
        price: '5,00€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/ae14f7c070f1cb32f9b63914c1c067ee.jpeg'
      },
      {
        id: 20,
        name: 'Alitas de Pollo (6 uds)',
        description: 'Alitas de pollo crujientes',
        price: '6,00€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/0468ec3ac3f6d9ed4133fd6671062d6f.jpeg'
      },
      {
        id: 21,
        name: 'Patatas Bravas',
        description: 'Patatas fritas con salsa brava picante',
        price: '4,50€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/933db9779006379aa78d196ae5e23172.jpeg'
      },
      {
        id: 22,
        name: 'Arroz Basmati',
        description: 'Arroz basmati aromático',
        price: '4,00€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/a301861dfc245193e515c32b203b0624.jpeg'
      },
      {
        id: 23,
        name: 'Falafel (6 uds)',
        description: 'Falafel crujiente de garbanzos',
        price: '5,50€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/266185c1a0f6ef728571d37e904e1081.jpeg'
      },
      {
        id: 24,
        name: 'Ensalada Kebabish',
        description: 'Tomate, lechuga, cebolla, zanahoria lila, queso y salsa',
        price: '5,00€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/a5e6af6032eea6638674d693a741599b.jpeg'
      },
      {
        id: 25,
        name: 'Ensalada con Atún',
        description: 'Tomate, lechuga, cebolla, zanahoria lila, atún y salsa',
        price: '5,50€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/f4c522734bf6ba1954388856da2080d4.jpeg'
      },
      {
        id: 26,
        name: 'Ensalada Especial',
        description: 'Tomate, lechuga, cebolla, zanahoria lila, atún, pepino, aceitunas y salsa',
        price: '6,00€',
        category: 'Raciones',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/9186da8f20e331d6fc7366c5098ade10.jpeg'
      }
    ]
  },
  {
    id: 'menus',
    name: 'Menús',
    icon: 'ri-file-list-3-line',
    items: [
      {
        id: 27,
        name: 'Menú Bocadillo Kebab',
        description: 'Bocadillo de kebab + Patatas + Bebida',
        price: '8,50€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/a1fe67f0cf36ec0a9c9a79a844dd85f0.jpeg'
      },
      {
        id: 28,
        name: 'Menú Durum',
        description: 'Durum + Patatas + Bebida',
        price: '9,50€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/94dc8a9f9d5197981eb6d1570a790f38.jpeg'
      },
      {
        id: 29,
        name: 'Menú Bocadillo Falafel',
        description: 'Bocadillo de falafel + Patatas + Bebida',
        price: '8,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/85d79570642b84672c6c61c05b0a9434.jpeg'
      },
      {
        id: 30,
        name: 'Menú Popcorn',
        description: 'Trocitos de pollo + Patatas + Bebida',
        price: '9,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/d6b97527f67d973391af0a62fbe64c4c.png'
      },
      {
        id: 31,
        name: 'Menú Pizza Lawasa',
        description: 'Pizza Lawasa + Patatas + Bebida',
        price: '10,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/a84dcf5ee69cedb961ea801d41b1f7b4.jpeg'
      },
      {
        id: 32,
        name: 'Menú Plato Kebab',
        description: 'Plato kebab + Patatas + Bebida',
        price: '9,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/255efbce8e4dbecc4e8a75cf55add4ff.jpeg'
      },
      {
        id: 33,
        name: 'Menú Hamburguesa',
        description: 'Hamburguesa + Patatas + Bebida',
        price: '8,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/0318405fc637287af784d81ed713b9d2.jpeg'
      },
      {
        id: 34,
        name: 'Menú Burrito de Pollo',
        description: 'Burrito de pollo + Patatas + Bebida',
        price: '10,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/3894edb6355130b3319c4ebbdacbdc87.jpeg'
      },
      {
        id: 35,
        name: 'Menú Infantil',
        description: 'Trocitos de pollo + Nuggets + Patatas + Bebida',
        price: '7,50€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/7e1547033af3138015a6a686e114a5d0.jpeg'
      },
      {
        id: 36,
        name: 'Menú Croquetas',
        description: 'Croquetas + Patatas + Bebida',
        price: '8,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/3cf1d32c89bb553698e6c7cf6d54e897.jpeg'
      },
      {
        id: 37,
        name: 'Menú Mitad Pollo',
        description: 'Mitad de pollo asado + Patatas + Bebida',
        price: '8,50€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/3e15324d060eccc2739ae48d94d2f3c7.jpeg'
      },
      {
        id: 38,
        name: 'Menú Pollo Asado Entero',
        description: 'Pollo asado entero + Patatas + Bebida',
        price: '13,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/977701ebbfaf9d627407854d7c0c0a9c.jpeg'
      },
      {
        id: 39,
        name: 'Menú Nuggets de Pollo',
        description: 'Nuggets de pollo + Patatas + Bebida',
        price: '7,50€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/f88c5c131925a13ee630f736c416d03d.jpeg'
      },
      {
        id: 40,
        name: 'Menú Alitas de Pollo',
        description: 'Alitas de pollo + Patatas + Bebida',
        price: '8,50€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/12b1c3facffd9f02b927f83a7fbfb73d.jpeg'
      },
      {
        id: 41,
        name: 'Menú Sis Kebab',
        description: 'Sis kebab + Patatas + Bebida',
        price: '10,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/f20d8968c8b3d2b847b78c73e97946c8.jpeg'
      },
      {
        id: 42,
        name: 'Menú Samosa',
        description: 'Samosa de carne o verdura + Patatas + Bebida',
        price: '7,00€',
        category: 'Menús',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/d5f9e0c72521ebc57551d63ad4a07f18.jpeg'
      }
    ]
  },
  {
    id: 'fried-chicken',
    name: 'Menús Fried Chicken',
    icon: 'ri-restaurant-fill',
    items: [
      {
        id: 43,
        name: '3 Piezas de Pollo Frito',
        description: '3 piezas de pollo frito + Patatas + Bebida',
        price: '8,50€',
        category: 'Menús Fried Chicken',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/945d542f4324550172b9b352106cb924.jpeg'
      },
      {
        id: 44,
        name: '6 Piezas de Pollo Frito',
        description: '6 piezas de pollo frito + Patatas + 2 Bebidas',
        price: '14,00€',
        category: 'Menús Fried Chicken',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/0234833d1c6d3940cb99a1ec257ae4c9.jpeg'
      },
      {
        id: 45,
        name: '9 Piezas de Pollo Frito',
        description: '9 piezas de pollo frito + Patatas + 2 Refrescos',
        price: '18,00€',
        category: 'Menús Fried Chicken',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/4e3e6fb40ac917a29347d6fefd443b03.jpeg'
      },
      {
        id: 46,
        name: '12 Piezas de Pollo Frito',
        description: '12 piezas de pollo frito + Patatas + 1 Litro de refresco',
        price: '22,00€',
        category: 'Menús Fried Chicken',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/421163b7b3e76ea24bc7ddb04a3622c0.jpeg'
      },
      {
        id: 47,
        name: '16 Piezas de Pollo Frito',
        description: '16 piezas de pollo frito + Patatas + 1 Litro de refresco',
        price: '26,00€',
        category: 'Menús Fried Chicken',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/a5e751ae5de17e1dcb4e29ffba9f86ce.jpeg'
      },
      {
        id: 48,
        name: 'Pollo Asado Entero',
        description: 'Pollo asado entero + Patatas',
        price: '12,00€',
        category: 'Menús Fried Chicken',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/f6232a4bf7e2d5898a5f1331adfa8ea3.jpeg'
      },
      {
        id: 49,
        name: 'Pollo Asado Entero con Bebida',
        description: 'Pollo asado entero + Patatas + Bebida',
        price: '13,00€',
        category: 'Menús Fried Chicken',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/977701ebbfaf9d627407854d7c0c0a9c.jpeg'
      }
    ]
  },
  {
    id: 'bebidas',
    name: 'Bebidas',
    icon: 'ri-cup-line',
    items: [
      {
        id: 50,
        name: 'Coca-Cola Lata',
        description: 'Refresco de cola 330ml',
        price: '2,00€',
        category: 'Bebidas',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/641ce66c05e1f08fb9b21ee0cd4abc2e.jpeg'
      },
      {
        id: 51,
        name: 'Fanta Naranja Lata',
        description: 'Refresco de naranja 330ml',
        price: '2,00€',
        category: 'Bebidas',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/bc164bbcd27efe38defa84face845870.jpeg'
      },
      {
        id: 52,
        name: 'Sprite Lata',
        description: 'Refresco de lima-limón 330ml',
        price: '2,00€',
        category: 'Bebidas',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/3f74f2fbb1c39fada9ebe8c31ae86d15.jpeg'
      },
      {
        id: 53,
        name: 'Nestea Lata',
        description: 'Té frío con limón 330ml',
        price: '2,00€',
        category: 'Bebidas',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/e301618391bd9c8a5d4331889c6c85ce.jpeg'
      },
      {
        id: 54,
        name: 'Agua Mineral Botella',
        description: 'Agua mineral 500ml',
        price: '2,00€',
        category: 'Bebidas',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/05e4dca5725302601ef78e5b65a92cb8.jpeg'
      },
      {
        id: 55,
        name: 'Pepsi 1 Litro',
        description: 'Refresco de cola 1L',
        price: '3,00€',
        category: 'Bebidas',
        image: 'https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/f2b446a9e750209aec6b3e587347da62.jpeg'
      }
    ]
  }
];

// Exportar todos los items en un solo array para facilitar el uso
export const menuItems = menuCategories.flatMap(category => 
  category.items.map(item => ({
    ...item,
    category: category.name
  }))
);
